/**
 * The build of a grouped entry found that the stored data the entry was based on changed after it
 * was added (another author, another tab): sending it would overwrite that change.
 */
export class PricedItemGroupEntryChanged extends Error {
  constructor() {
    super('The stored data of a grouped change changed after the change was added to the group.');
    this.name = 'PricedItemGroupEntryChanged';
  }
}
